/**
 * Detalle de un pedido del historial (ADM-09), en el modal del backoffice.
 *
 * El id viene de la URL (`?pedido=`), asi que el modal se puede enlazar y
 * sobrevive a recargar. Se pide el pedido completo al abrir y no se reusa la
 * fila de la tabla: el detalle trae lo que la tabla no necesita (pago, paso
 * por Random, correos, fotos de lo comprado).
 */
import type { PedidoAdminDetalle } from '@elcarpintero/compartido';

import { usePeticion } from '../../hooks/use-peticion';
import { obtenerPedidoAdmin } from '../../servicios/administracion.servicio';
import { fechaHoraCompleta } from '../../utilidades/formato';
import { AvisoError, Cargando } from '../comunes/EstadoPeticion';
import { BotonPdfPedido } from './BotonPdfPedido';
import { DetallePedido } from './DetallePedido';
import { Modal } from './Modal';

export interface ModalPedidoProps {
  /** Nulo mantiene el modal cerrado. */
  id: number | null;
  /** La ruta desde donde se abrio, para que "Volver" de una ficha de producto regrese aca. */
  volver: string;
  onCerrar(): void;
}

function sinPedido(): Promise<PedidoAdminDetalle | null> {
  return Promise.resolve(null);
}

export function ModalPedido({ id, volver, onCerrar }: ModalPedidoProps) {
  const { estado, datos, error } = usePeticion(
    (senal) => (id === null ? sinPedido() : obtenerPedidoAdmin(id, senal)),
    [id ?? 0],
  );

  return (
    <Modal
      titulo={datos !== null ? `Pedido ${datos.referencia}` : 'Pedido'}
      bajada={datos !== null ? `Creado el ${fechaHoraCompleta(datos.creadoEn)}` : undefined}
      abierto={id !== null}
      ancho="amplio"
      onCerrar={onCerrar}
    >
      {estado === 'cargando' ? <Cargando que="el pedido" /> : null}
      {estado === 'error' ? <AvisoError error={error} /> : null}
      {datos !== null ? (
        <>
          <div className="acciones-pedido">
            <BotonPdfPedido id={datos.id} referencia={datos.referencia} forma="boton" />
          </div>
          <DetallePedido pedido={datos} volver={volver} />
        </>
      ) : null}
    </Modal>
  );
}
